<template>
  <div id="BrandPublicationStatus">
    <!-- 状态 -->
    <div class="indicator">
      <i class="indicator-dot" :class="publicationStatus.color" />
      <span>{{ publicationStatus.text }}</span>
      <el-popover
        v-if="publicationStatus.info === 'failed'"
        visible-arrow
        popper-class="publication-reason-popover"
        trigger="click"
        placement="bottom-start"
      >
        <div class="reason">
          {{ publicationStatus.reason || '未知原因' }}
        </div>
        <div slot="reference" class="indication-info">查看失败原因</div>
      </el-popover>
    </div>
    <!-- 按钮 -->
    <qm-button
      v-if="showPublicationStatusButton"
      :text="publicationStatus.buttonText"
      @click="handleClickPublicationStatusInfo(publicationStatus.info)"
      style="margin-left: 16px"
    />
    <router-link
      v-else-if="publicationStatus.buttonText"
      :to="`/${pubType}/${publicationId}/publish`"
    >
      <qm-button :text="publicationStatus.buttonText" />
    </router-link>
    <!-- 推广 -->
    <qm-button
      v-if="showPromotionButton"
      text="推广"
      @click="bindPromotion"
      style="margin-left: 16px"
    />
    <!-- 预览 -->
    <el-popover
      v-if="!(pubType === 'podcast' && !publicationInfo.appId)"
      visible-arrow
      popper-class="publication-preview-popover"
      trigger="hover"
      placement="bottom-end"
    >
      <div class="preview" :class="{'show-border': showQrcodeBorder}">
        <img class="preview-qrcode" :src="publicationQrcode" alt="二维码" />
        <div class="preview-type" v-if="publicationQrcodeType">
          <i class="indicator-dot" :class="publicationStatus.color" />
          <div>{{ publicationStatus.text }}</div>
        </div>
        <div class="preview-tip"
          >微信扫码{{
            publicationStatus.text === '未发布' ? '预览' : '访问'
          }}</div
        >
      </div>
      <div class="preview" slot="reference">
        <img src="/static/icon/icon-qrcode.svg" alt="qr-code" />
        <div>预览</div>
      </div>
    </el-popover>
    <!-- 弹窗 -->
    <el-dialog
      class="publication-info-dialog"
      :lock-scroll="false"
      :show-close="false"
      :modal-append-to-body="false"
      width="400px"
      :visible.sync="publicationDialogShow"
    >
      <template slot="title">
        <!-- 轻芒杂志发布成功 publicPublishSuccess -->
        <qm-card
          v-if="publicationStatus.info === 'publicPublishSuccess'"
          class="publish public-publish-success"
        >
          <header>
            <div>发布成功</div>
            <div @click="handleClickClosePublicationDialog">
              <icon name="close" />
            </div>
          </header>
          <main>
            <img class="qrcode" :src="publicationQrcode" alt="二维码" />
            <div class="success-tip">
              已成功发布至轻芒杂志，微信扫码查看。
              可以在首页随时发布为独立小程序。
            </div>
          </main>
          <footer>
            <qm-button
              text="好的"
              @click="handleClickClosePublicationDialog(true)"
            />
          </footer>
        </qm-card>
        <!-- 未发布 offline 公有版本已发布 publicPublished -->
        <qm-card
          v-if="
            publicationStatus.status === 'offline' ||
              publicationStatus.info === 'publicPublished' ||
              publicationStatus.status === 'needUpdate'
          "
          class="publish"
        >
          <header>
            <div>发布小程序</div>
            <div @click="handleClickClosePublicationDialog">
              <icon name="close" />
            </div>
          </header>
          <main>
            <div class="standard">
              <span
                >小程序需提交审核，符合微信审核规范才可以发布，详情请参考</span
              >
              <a
                href="https://developers.weixin.qq.com/miniprogram/product/reject.html#3-%E5%B0%8F%E7%A8%8B%E5%BA%8F%E6%95%B4%E4%BD%93%E5%AE%A1%E6%A0%B8%E8%A7%84%E5%88%99"
                target="_blank"
                >微信审核规范</a
              >
            </div>
            <div class="characteristics">
              <div class="benefit">
                <div class="left">
                  <img src="/static/icon/icon-publish-li.svg" alt />
                </div>
                <div class="right">微信搜索直达</div>
              </div>
              <div class="benefit">
                <div class="left">
                  <img src="/static/icon/icon-publish-li.svg" alt />
                </div>
                <div class="right">「最近小程序」入口</div>
              </div>
              <div class="benefit">
                <div class="left">
                  <img src="/static/icon/icon-publish-li.svg" alt />
                </div>
                <div class="right">支持广告变现</div>
              </div>
              <div class="benefit">
                <div class="left">
                  <img src="/static/icon/icon-publish-li.svg" alt />
                </div>
                <div class="right">拥有独立、专享品牌</div>
              </div>
            </div>
          </main>
          <footer>
            <qm-button text="发布" @click="handleClickPublish" />
          </footer>
        </qm-card>
        <!-- 私有版本审核中 reviewing -->
        <qm-card
          v-if="publicationStatus.info === 'reviewing'"
          class="dialog-finishHosted publish-card"
        >
          <header class="header">
            {{
              publicationStatus.operator === 'internal'
                ? '轻芒预审中'
                : '微信审核中'
            }}
          </header>
          <main class="body">
            <div v-if="publicationStatus.operator === 'internal'">
              轻芒正在进行预审，以提高微信审核的通过率，预审需要 1-2
              个工作日，通过后会自动提交微信审核，并会在「创作者与轻芒」公众号发送提醒
            </div>
            <div v-else>
              已经通过轻芒预审并提交微信审核，微信审核需要 2-7
              个工作日，审核结果会通过「创作者与轻芒」公众号发送提醒
            </div>
            <div class="time">
              提交审核时间：{{ publicationStatus.createdTime }}
            </div>
            <div class="template">
              模板号：
              <span>{{ publicationStatus.templateId }}</span>
            </div>
          </main>
          <footer class="footer">
            <qm-button
              text="我知道了"
              @click="handleClickClosePublicationDialog"
            />
          </footer>
        </qm-card>
        <!-- 审核失败 failed -->
        <qm-card
          v-if="publicationStatus.info === 'failed'"
          class="dialog-finishHosted dialog-failed publish-card"
        >
          <header class="header">
            <div>请确认问题已修改</div>
          </header>
          <main class="body">
            <div>
              上次提审不通过的原因是「{{
                publicationStatus.reason
              }}」，为了提高审核通过率，请确认提到的问题已修改。
            </div>
          </main>
          <footer class="footer">
            <template>
              <qm-button
                text="取消"
                class="cancel"
                @click="publicationDialogShow = false"
              />
              <qm-button text="确认" @click="handleClickPublish" />
            </template>
          </footer>
        </qm-card>
        <!-- 授权失效 authorizationFailed -->
        <qm-card
          v-if="publicationStatus.info === 'authorizationFailed'"
          class="dialog-finishHosted publish-card"
        >
          <header class="header">微信授权失效</header>
          <main class="body">
            <div class="row alert">
              <img
                src="/static/icon/publication-icon/publication-info-alert.svg"
                alt
              />
              <span>小程序授权失效，请重新授权。</span>
            </div>
            <div class="row finish-content" style="margin-top: 16px;">
              请确认已经授权给「轻芒小程序+」
            </div>
            <div class="row finish-content">并勾选所有授权的权限集合</div>
          </main>
          <footer class="footer">
            <qm-button text="重新授权" @click="handleClickAuthorizeAgain" />
          </footer>
        </qm-card>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import * as api from 'src/api/index'
import * as qm from 'src/utils/utils'
import {mapGetters, mapActions} from 'vuex'
import publicationStatus from 'src/components/publication/publicationStatus.js'
export default {
  name: 'BrandPublicationStatus',
  mixins: [publicationStatus],
  props: {},
  data() {
    return {
      pubType: this.$route.path.split('/')[1],
      // 发布状态的弹窗数据
      publicationDialogShow: false,
      // 发布状态的弹窗状态
      // publicationDialogType: undefined,
      // 最新模板
      templateIdNewest: null,
    }
  },
  computed: {
    showPromotionButton() {
      return ![
        'authorizationFailed',
        'offline',
        'rejected',
        'reviewing',
        // 已发布至「轻芒杂志」
        'publicPublished',
        'hasAuthored',
      ].includes(this.publicationStatus.status)
    },
    publicationId() {
      return this.$route.params.publicationId
    },
    showPublicationStatusButton() {
      return [
        'offline',
        'rejected',
        'reviewing',
        'authorizationFailed',
        // 已发布至「轻芒杂志」
        'publicPublished',
        'hasAuthored',
      ].includes(this.publicationStatus.status)
    },
    trialVersionQrcode() {
      // 有线上版本用线上版本
      const $released = qm.has(this.publicationInfo, 'appInfo.versions.release')
      const publicationId = this.publicationId
      const appId = this.publicationInfo.appId
      return qm.generateMinaCode('page', {
        isPreview: true,
        appId,
      })
    },
    publicationQrcodeType() {
      // 有线上版本用线上版本
      const $released = qm.has(this.publicationInfo, 'appInfo.versions.release')
      const publicationId = this.publicationId
      const appId = this.publicationInfo.appId
      if ($released) {
        return ''
      }
      // 有审核中 or 审核通过的体验版本用体验码
      const $reviewed = qm.has(this.publicationInfo, 'appInfo.versions.review')
      if ($reviewed) {
        return '体验'
      }
      // 否则统统使用公共版本的二维码
      if (
        qm.has(this.publicationInfo, 'appInfo.versions.review') &&
        this.publicationInfo.appInfo.versions.review.status === 'offline'
      ) {
        return '预览'
      }
      return ''
    },
    publicationQrcode() {
      // 有线上版本用线上版本
      const $released = qm.has(this.publicationInfo, 'appInfo.versions.release')
      const publicationId = this.publicationId
      const appId = this.publicationInfo.appId
      if ($released) {
        return qm.generateMinaCode('page', {
          publicationId,
          appId,
          isPrivate: $released,
        })
      }
      // 有审核中 or 审核通过的体验版本用体验码
      const $reviewed = qm.has(this.publicationInfo, 'appInfo.versions.review')
      if ($reviewed) {
        return qm.generateMinaCode('page', {
          isPreview: $reviewed,
          appId,
        })
      }
      // 否则统统使用公共版本的二维码
      return qm.generateMinaCode('page', {
        publicationId,
      })
    },
    showQrcodeBorder() {
      /* eslint-disable */
      const APP_QINGMANG = 'wx05790b1180642960'
      /* eslint-enable */
      // 有线上版本用线上版本
      const $released = qm.has(this.publicationInfo, 'appInfo.versions.release')
      if ($released) {
        return false
      }
      // 有审核中 or 审核通过的体验版本用体验码
      const $reviewed = qm.has(this.publicationInfo, 'appInfo.versions.review')
      if ($reviewed) {
        return true
      }
      // 否则统统使用公共版本的二维码
      return false
    },
    ...mapGetters({
      publicationInfo: 'publicationInfo',
    }),
  },
  methods: {
    async handleClickPublish() {
      // 发布至「轻芒杂志」
      // if (this.publicationStatus.status === 'offline') {
      //   await this.publishPublic()
      // } else {
      //   this.publicationDialogShow = false
      // }
      this.handleClickAuthorizeAgain()
    },
    // 点击重新去授权
    handleClickAuthorizeAgain() {
      this.publicationDialogShow = false
      this.$router.push(`/${this.pubType}/${this.publicationId}/publish`)
    },
    async publishPublic() {
      try {
        const res = await api.publishPublication(this.publicationId, undefined)
        if (res.ok) {
          await this.actionSetPublicationInfo(true)
          this.publicationDialogShow = false
        } else {
          throw new Error(res.errorMessage || res.error.desc)
        }
      } catch (e) {
        qm.log('handleClickPublish error:', e)
        this.$message.error(e.message)
      } finally {
      }
    },
    handleClickPublicationStatusInfo(info, step) {
      // 发布小程序
      if (
        this.publicationStatus.status === 'offline' ||
        this.publicationStatus.info === 'publicPublished' ||
        this.publicationStatus.status === 'needUpdate'
      ) {
        qm.GA('ui', 'clicked_publish', this.pubType)
      }
      document.body.click()
      this.publicationDialogShow = true
      if (step) {
        this.publicationStatus.step = step
      } else {
        this.publicationStatus.step = ''
      }
    },
    // 关闭对话框
    handleClickClosePublicationDialog(refesh) {
      this.publicationDialogShow = false
      if (refesh) {
        this.actionSetPublicationInfo(true)
      }
      // this.publicationDialogType = undefined
    },
    bindPromotion() {
      this.$router.push(`/${this.pubType}/${this.publicationId}/promotion`)
    },
    // 点击
    ...mapActions({
      actionSetPublicationInfo: 'actionSetPublicationInfo',
    }),
  },
  created() {},
}
</script>

<style lang="scss">
.el-popper.publication-reason-popover {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
  margin: 0;
  border-radius: 0;
  padding: 0;
  .reason {
    width: 244px;
    min-height: 138px;
    padding: 18px 20px;
  }
}
.el-popper.publication-preview-popover {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
  border-radius: 0;
  padding: 0;
  .preview {
    padding: 20px 26px;
    text-align: center;
    color: #333;
    .preview-qrcode {
      width: 120px;
      height: 120px;
    }
    .preview-type {
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      .indicator-dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-right: 6px;

        &.online {
          background-color: #4ece3c;
        }

        &.offline {
          background-color: #868f99;
        }

        &.failed {
          background-color: #f84b1c;
        }

        &.reviewing {
          background-color: #f88d1c;
        }
      }
    }
    .preview-tip {
      margin-top: 15px;
    }
  }
  .preview.show-border {
    img {
      border: 1px solid #cccccc;
    }
  }
}
#BrandPublicationStatus {
  display: flex;
  align-items: center;
  color: initial;
  font-size: initial;
  // 状态
  .indicator {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: #666666;
    .indicator-dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      margin-right: 6px;

      &.online {
        background-color: #4ece3c;
      }

      &.offline {
        background-color: #868f99;
      }

      &.failed {
        background-color: #f84b1c;
      }

      &.reviewing {
        background-color: #f88d1c;
      }
    }
    .indication-info {
      cursor: pointer;
      margin-left: 19px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 148, 238, 1);
    }
  }
  // 预览
  .preview {
    margin-left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 72px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 1);
    font-size: 14px;
    img {
      margin-right: 4px;
      width: 20px;
      height: 20px;
    }
  }

  .publication-info-dialog {
    .publish {
      width: 480px;
      padding: 0 40px;
      header {
        font-size: 18px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        height: 72px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .icon {
          font-size: 16px;
          cursor: pointer;
        }
      }
      main {
        display: flex;
        flex-direction: column;
        align-items: center;
        .price {
          margin-top: 17px;
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          .number {
            font-size: 22px;
            font-weight: bold;
            margin-right: 4px;
          }
        }
        .standard {
          margin-top: 6px;
          width: 100%;
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          a {
            margin-left: 4px;
            color: #4a90e2;
          }
        }
        .characteristics {
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-top: 20px;
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .benefit {
            margin-top: 17px;
            display: flex;
            align-items: center;
            width: 50%;
            .left {
              display: flex;
              align-items: center;
              margin-right: 13px;
            }
          }
        }
      }
      footer {
        margin-top: 39px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 32px;
        .qm-button {
          width: 100%;
        }
        .qingmang {
          cursor: pointer;
          margin-top: 16px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }
      }
    }
    .public-publish-success {
      .qrcode {
        margin-top: 58px;
        width: 200px;
        height: 200px;
      }
      .success-tip {
        margin-top: 33px;
      }
    }

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;
    }
    .publish-card {
      padding: 0 40px;
      .footer {
        .qm-button {
          width: 100%;
        }
      }
    }
    .dialog-failed {
      display: flex;
      align-items: center;
      flex-direction: column;
      .header {
        font-size: 18px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
      .footer {
        align-self: flex-end;
      }
    }
    .dialog-finishHosted {
      .header {
        justify-content: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        padding: 22px 0;
        display: flex;
        align-items: center;
        min-height: 72px;
      }
      .body {
        color: #555;
        font-size: 14px;
        .time {
          margin-top: 21px;
        }
        .template {
          margin-top: 2px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          span {
            color: #0094ee;
          }
        }
      }
      .footer {
        padding: 20px 0;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
      }
    }
  }
}
</style>
